import React, { Component } from "react";
import Checkout from "../Checkout";

interface Props {
  match: any;
  selectedCurrency: string;
  currentUser: {
    country: string;
    kind: string;
  };
}

class RenewalPay extends Component<Props, {}> {
  render() {
    const slug = this.props.match.params.slug;

    return (
      <div className="facelift-checkout">
        <Checkout
          slug={slug}
          path="renew"
          paymentType="subscription"
          paymentUrl={`/api/checkout/renewals/${slug}`}
          selectedCurrency={this.props.selectedCurrency}
          isCurrentUserPresent={this.props.currentUser.kind === "current-user"}
        />
      </div>
    );
  }
}

export default RenewalPay;
